var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"button-a",style:(_vm.style),attrs:{"plain":"","disabled":_vm.disabled}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }